import {
  ModalProps,
  Modal,
  useModals,
  Button,
  Input,
  Stack,
  Switch,
  Text,
} from "@skailer-com/uikit";

import { ApiTimeOffBreakdownItem } from "@/types/time-off/time-off.types.ts";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ApiTimeOffPeriodTrackingTime } from "@/types/time-off/time-off-policy.types.ts";

export interface TimeOffBreakdownCustomAmountModalProps extends ModalProps {
  items: ApiTimeOffBreakdownItem[];
  index: number;
  period_track_type?: ApiTimeOffPeriodTrackingTime;
  onApply: (value: { amount: number; applyToAll: boolean }) => void;
}

export const TimeOffBreakdownCustomAmountModal = ({
  items,
  index,
  period_track_type,
  onApply,
  ...props
}: TimeOffBreakdownCustomAmountModalProps) => {
  const { id } = { ...props };
  const { t } = useTranslation();
  const { close } = useModals();

  const current = items[index];

  const [amount, setAmount] = useState(String(current.amount));
  const [applyToAll, setApplyToAll] = useState(false);

  const save = () => {
    const num = Number(amount);

    const safe = isNaN(num)
      ? current.min_amount
      : Math.min(Math.max(num, current.min_amount), current.max_amount);

    onApply({ amount: safe, applyToAll });
    close(id);
  };
  const isHours = period_track_type === ApiTimeOffPeriodTrackingTime.hours;
  const pluralKey = isHours ? "plurals:plural_hours" : "plurals:plural_day";

  return (
    <Modal
      {...props}
      id={id}
      title={t("time_off:custom_amount")}
      withCloser
      actions={
        <Button size="lg" className={"w-full"} onClick={save}>
          {t("common:apply")}
        </Button>
      }
    >
      <Stack gap={"sm"}>
        <Input
          label={t("time_off:enter_amount_in_units", {
            units: isHours
              ? t("time_off:hours_prepositional").toLowerCase()
              : t("time_off:days_prepositional").toLowerCase(),
          })}
          type="number"
          min={0}
          max={current.max_amount}
          step={0.5}
          value={String(amount)}
          onChange={(e) => {
            setAmount(e.target.value);
          }}
        />
        <Text className="text-secondary text-xs">
          {`${t("time_off:minimum_fraction_is")} ${t(pluralKey, {
            count: parseFloat("0.5"),
          })}`}
        </Text>

        <Switch
          title={t("time_off:apply_to_all_workdays")}
          description={t("time_off:apply_to_all_workdays_caption")}
          checked={applyToAll}
          onChange={setApplyToAll}
        />
      </Stack>
    </Modal>
  );
};
